import { Component, OnInit } from "@angular/core";
import { BaseComponent } from "../pages/base.component";
import { CommonService } from "../services/common.service";
import { ToastrService } from "ngx-toastr";
declare var $: any;

@Component({
  selector: "app-new-student-dashboard",
  templateUrl: "./new-student-dashboard.component.html",
  styleUrls: ["./new-student-dashboard.component.css"],
})
export class NewStudentDashboardComponent
  extends BaseComponent
  implements OnInit
{
  dashboardResponse: any;
  newsList: Array<any> = [];
  news: any;
  showAll: boolean = false;
  currentDate: Date = new Date();
  isApplicant: any = localStorage.getItem("IsApplicant");
  message: any;
  constructor(CommonService: CommonService, toastr: ToastrService) {
    super(CommonService, toastr);
  }

  async ngOnInit() {
    const decryptedValue: any = await this.CommonService.decryptAesGcm(
      this.roleId,
      this.CommonService.key
    );
    this.roleId = decryptedValue;
    this.getDashboardDetails();
    this.getNewsList();
    this.GetPopupByStatus();
  }
  getDashboardDetails() {
    this.activeSpinner();
    this.CommonService.postCall("Dashboard/GetStudentDashboardDetails", {
      USER_ID: this.userId,
      TNT_CODE: this.TenantCode,
    }).subscribe(
      (res: any) => {
        this.dashboardResponse = res;
        this.deactivateSpinner();
      },
      (e) => {
        this.deactivateSpinner();
      }
    );
  }
  getNewsList() {
    this.newsList = [];
    let payload = {
      TNT_CODE: localStorage.getItem("TenantCode"),
      ROLE_NAME: localStorage.getItem("RoleName"),
    };
    this.CommonService.postCall("News/GetNewsList", payload).subscribe(
      (response: any) => {
        this.newsList = response;
      }
    );
  }
  getNews(EVENT_ID) {
    this.news = {};
    let payload = {
      EVENT_ID: EVENT_ID,
    };
    this.CommonService.postCall("News/Get", payload).subscribe(
      (response: any) => {
        this.news = response;
      }
    );
  }
  toggleViewAll() {
    this.showAll = !this.showAll;
  }
  GetPopupByStatus() {
    this.CommonService.postCall("Registration/GetAlertByStatus", {
      USER_ID: this.userId,
      COURSEID: +localStorage.getItem("courseId"),
    }).subscribe((res: any) => {
      this.message = res[0];
      if (this.message?.IS_SUBMIT == 5) {
        $("#alertPopup").modal("show");
      }
    });
  }
}
